import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { useLegacyEventNotificationTypes } from "components/event-notifications/hooks/useEventNotifications";
import LegacyNotificationForm from "./LegacyNotificationForm";
const LegacyNotificationFormContainer = ({ ...props }) => {
  const { t } = useTranslation("event_notifications");
  const { data } = useLegacyEventNotificationTypes();
  const allLegacyTypes = data == null ? void 0 : data.types;
  if (!allLegacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: t("legacy.loading") }));
  }
  return /* @__PURE__ */ React.createElement(LegacyNotificationForm, { ...props, legacyTypes: allLegacyTypes });
};
export default LegacyNotificationFormContainer;
